import HomePage from "../LandingPage/templates/HomePage/HomePage";

const LandingPageIndex = () => {
    return <HomePage />;

};

export default LandingPageIndex;
